import { modalController } from '@ionic/vue'
import Detail from './detail.vue'
import './_theme/ion-modal.sass'


export default {
	create(options) {
		return modalController.create({
			...options,
			animated: window.innerWidth >= 992 ? false : true,
			component: Detail,
			cssClass: 'result-modal',
			backdropDismiss: true
		})
	}
}